export const Select = ({ ...props }) => {
  return (
    <select
      {...props}
      className={`bg-bgAlt ${props.multiple ? `overflow-hidden` : `border-r-[16px] border-r-solid border-bgAlt`} px-3 py-5 type-label-l rounded-sm text-text placeholder:text-accent`}
    >
      <option value={""} className={`${props.multiple ? `py-2 type-label-l` : ``}`}>
        {props.placeholder ?? "Please select"}
      </option>
      {props.choices.map(
        (
          choice: {
            value: string
            text: string
          },
          index: number,
        ) => (
          <option key={index} value={choice.value} className={`${props.multiple ? `py-2 type-label-l` : ``}`}>
            {choice.text}
          </option>
        ),
      )}
    </select>
  )
}
